<div [id]="block.blockId"
     [class]="'z-1 relative ' + (blockClass ? (blockClass + ' ') : '') + theme.fullTheme + (block.class_overwrite ? (' ' + block.class_overwrite) : '' ) + ' ' + (componentOffset)">
    <div class="container m-auto relative overflow-hidden px-3 lg:px-0">
        <app-seaweed *ngIf="block.background_seaweed" [alignment]="block.seaweed_alignment.value"
                     [theme]="theme"></app-seaweed>

        <div [class]="'relative ' + (container ? 'md:px-6 lg:px-8 xl:!px-42' : '')"
             [ngClass]="{'py-7': theme.theme !== 'light'}">
            <div class="grid">
                <div class="col-12 md:col-6 lg:col-4"
                     [ngClass]="{'md:col-6 lg:col-4': first, 'md:col-6 lg:col-2 flex-1': !first}"
                     *ngFor="let navigational of block.blocks; let first = first">
                    <a [href]="navigational.entry || navigational.url"
                       target="_blank"
                       [class]="'rounded-2xl px-5 py-6 no-underline hover:underline block ' + theme.current.boxed"
                    >
                        <div [innerHTML]="navigational.title | safeHTML"
                             [class]="'font-bold line-height-3 text-base [&>p]:mb-0 [&>p]:mt-0 ' + theme.current.textSubtitleContrast"></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
